(function(){
    'use strict'

    angular
    .module('app.puestos')
    .controller('Puestos', Puestos);

    Puestos.$inject = ['$animationsSrv', 'PuestosService', 'logger', '$location', 'UserInfoService'];

    function Puestos($animationsSrv, PuestosService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.puestos = [];
        vm.title = 'Puestos';

        vm.goToEdit = function(puesto){
            
            var path = '/editar-puesto/';

            if(puesto){
                $location.path(path + puesto.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = PuestosService.getAll();

            promise
            .then(function(puestos){
                vm.puestos = puestos;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los puestos.');
                        break;
                }
            });
        };

        vm.delete = function(puesto){
            var promise = PuestosService.remove(puesto);
            
            promise
            .then(function(response){
                vm.puestos = vm.puestos.filter(function(g) {
                    return g.id !== puesto.id;
                });
                logger.success('Puesto eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Puesto');
                        break;
                }
                
            });   
        };

    }
})();